import DefaultImage from './../../../assets/Icon/default_image.png';

export const defaultImageHelper = (e) => {
    if (e?.target?.onerror === undefined || e?.target?.onerror === null || e?.target?.onerror === "" || e?.target?.onError === undefined || e?.target?.onError === null || e?.target?.onError === "") {
        e.target.src = DefaultImage
    }
    return e;
}